<template>
    <div class="quote-form-new form-wrapper">

        <div class="quote-container">
            <el-form :model="quoteForm" :rules="rules" ref="quoteForm" class="card">

                <div v-if="!done">
                    <!-- Contact Information -->
                    <div>
                        <div class="section-header">
                            <h2>Contact Information</h2>
                            <p>This information will be used to contact you about your quote</p>
                        </div>

                        <div class="section-body">
                            <el-row :gutter="16">

                                <el-col :xs="24" :sm="12">
                                    <el-form-item prop="first_name" label="First Name">
                                        <el-input placeholder="John" v-model="quoteForm.first_name" />
                                    </el-form-item>
                                </el-col>

                                <el-col :xs="24" :sm="12">
                                    <el-form-item prop="last_name" label="Last Name">
                                        <el-input placeholder="Doe" v-model="quoteForm.last_name" />
                                    </el-form-item>
                                </el-col>

                                <el-col :xs="24" :sm="12">
                                    <el-form-item prop="email" label="Email Address">
                                        <el-input placeholder="johndoe@mail.com" v-model="quoteForm.email" />
                                    </el-form-item>
                                </el-col>

                                <el-col :xs="24" :sm="12">
                                    <el-form-item prop="phone" label="Phone Number">
                                        <el-input placeholder="1234567890" v-model="quoteForm.phone">
                                            <template slot="prepend">{{ serviceLocale.phone_prefix }}</template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <Divider :primary-color="customizer.appearance.accentColor" />
                        </div>
                    </div>

                    <!-- Service Address -->
                    <div>
                        <div class="section-header">
                            <h2>Service Address</h2>
                            <p>Where would you like us to clean?</p>
                        </div>

                        <div class="section-body">
                            <el-row :gutter="20">

                                <el-col :xs="16" :sm="18">
                                    <el-form-item prop="street_address" label="Street">
                                        <gmap-autocomplete
                                            :value="quoteForm.street_address"
                                            placeholder="123 Main Street"
                                            @place_changed="setPlace"
                                            @input="setPlace"
                                            :select-first-on-enter="true"
                                            style="width: 100%;"
                                            class="gmap-autocomplete"
                                        >
                                        </gmap-autocomplete>
                                        <el-input placeholder="123 Main Street" v-model="quoteForm.street_address" style="display: none;" />
                                    </el-form-item>
                                </el-col>

                                <el-col :xs="8" :sm="6">
                                    <el-form-item prop="apt_number" label="Apt #">
                                        <el-input placeholder="Apt 101" v-model="quoteForm.apt_number" />
                                    </el-form-item>
                                </el-col>

                                <el-col :xs="serviceLocale.states ? 24 : 16" :sm="serviceLocale.states ? 9 : 18">
                                    <el-form-item prop="city" label="City">
                                        <el-input placeholder="Anytown" v-model="quoteForm.city" />
                                    </el-form-item>
                                </el-col>

                                <template v-if="serviceLocale.states">
                                    <el-col :xs="16" :sm="9">
                                        <el-form-item prop="selected_state" label="State">
                                            <el-select class="w-100" v-model="quoteForm.selected_state" autocomplete="disabled" filterable placeholder="State" style="width: 100%;">
                                                <el-option
                                                v-for="state in serviceLocale.states"
                                                :key="state.abbreviation"
                                                :label="state.name"
                                                :value="state.abbreviation"
                                                style="font-family: 'Inter';"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </template>

                                <el-col :xs="8" :sm="6">
                                    <el-form-item prop="zipcode" :label=" _placeholder('zipcode') || 'Zip Code'">
                                        <el-input placeholder="67890" v-model="quoteForm.zipcode" />
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <Divider :primary-color="customizer.appearance.accentColor" />
                        </div>
                    </div>

                    <!-- Notes -->
                    <div>
                        <div class="section-header">
                            <h2>Would you like to add any notes?</h2>
                            <p>Share with us more details</p>
                        </div>

                        <div class="section-body">
                            <el-row>
                                <el-col :span="24">

                                    <el-form-item prop="notes">
                                        <el-input
                                            type="textarea"
                                            :rows="3"
                                            placeholder="Tell us about the service you want, what special needs you may have, or any other important information."
                                            v-model="quoteForm.customerNotes">
                                        </el-input>
                                    </el-form-item>

                                </el-col>
                            </el-row>
                            <!-- <Divider :primary-color="customizer.appearance.accentColor" /> -->
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <el-button @click="quote" type="primary" :loading="spinner_actived">
                        Request Quote
                    </el-button>

                </div>

                <div v-else>
                    <formthankyou :client="clientId" :company_logo="companyLogo" :company_name="companyName" />
                </div>

            </el-form>
        </div>

    </div>
</template>
<script>

import phoneValidator from 'phone'
import Formthankyou from './thankyou/Formthankyou.vue'
import Divider from '../bookingForm/src/Divider.vue'

export default {

    props: {
        clientId      : {
            type      : String,
            required  : true
        },
        customer: {
            type: Object
        },
        bookInfo:{
            type: Object
        },
        locationId : {
            type: String,
            required : true,
        },
        customizer:{
            type: Object,
            default: () => ({
                appearance: {
                    formStyle: "default_new",
                    accentColor: "#4285f4",
                    servicesStyle: "default",
                    formBorderRadius: 30,
                    inputBorderRadius: 12}
            })
        },
        companyName: {
            type     : String,
            required : true
        },
        companyLogo: {
            type: String,
        },
    },

    components: {
        Formthankyou,
        Divider
    },

    data() {

        var checkNames = (rule, value, callback) => {
            var RegExpression = /^[a-zA-Z\s']*$/
            if (RegExpression.test(value)) {
                callback();
            } else {
                callback(new Error('Name cannot contain numbers'));
            }
        };

        var checkPhone = (rule, value, callback) => {
            if (value) {
                let validationResult = phoneValidator(this.quoteForm.phone, this.countryShortName, true);
                
                if (validationResult.length) {
                    callback();
                } else {
                    callback(new Error('Invalid Phone Number'));
                }
            }
            else {
                callback(new Error('Phone is required'));
            }
        };

        return {
            primaryColor: '#2f80ed',
            done              : false,
            error             : false,
            rules             : {
                first_name     : [
                    { required: true, message: 'First Name is required', trigger: ['blur', 'change'] },
                    { validator: checkNames, trigger: 'blue' }
                ],
                last_name      : [
                    { required: true, message: 'Last Name is required', trigger: ['blur', 'change'] },
                    { validator: checkNames, trigger: 'blue' }
                ],
                email          : [
                    { required: true, message: 'Email Address is required', trigger: 'blur' },
                    { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
                ],
                phone          : [
                { required: true, validator: checkPhone, trigger: ['blur', 'change'] },
                ],
                street_address : [
                    { required: true, message: 'Street Address is required', trigger: ['blur', 'change'] }
                ],
                city           : [
                    { required: true, message: 'City is required', trigger: ['blur', 'change'] }
                ],
                selected_state : [
                    { required: true, message: 'State is required', trigger: ['blur', 'change'] },
                ],
                zipcode        : [
                    { required: true, message: 'Zip Code is required', trigger: ['blur', 'change'] },
                    { min: 2, max: 15, message: 'Zip Code lenght error', trigger: ['blur', 'change'] }
                ],
            },

            states            : null,
            quoteForm          : {
                city               : '',
                email              : '',
                hours              : [],
                phone              : '',
                zipcode            : '',
                minutes            : [],
                time_hour          : 'AM',
                last_name          : '',
                first_name         : '',
                apt_number         : '',
                selected_date      : null,
                selected_hour      : null,
                street_address     : '',
                validatedPhone     : null,
                selected_minute    : null,
                customerNotes : '',
                selected_state : null,
            },
            settings          : null,
            book_intent       : '',
            priceBoxTop       : 10,
            customer_id       : '',
            company_name      : '',
            spinner_code      : false,

            serviceLocale     : {
                states:null,
                currency:{}
            },
            spinner_actived   : false,

            bookZillow        : {
                zillow_active: false,
                zillow_id: '',
                images: [],
                bedrooms: '',
                bathrooms: '',
                sqft: ''
            },

            coordinates: {
                lat: 0,
                lng: 0
            },
        };

    },

    created() {

        // Listen for query string params on the parent
        window.addEventListener('message', this.populateInputs);

        let locationNew = (this.locationId != undefined && this.locationId > -1)? this.locationId : 0

        this.$http({
            url: `/booking/booking_form/get_data/` + this.clientId+`/` + locationNew,
            method: 'GET',
        }).then((res) => {

            let data = res.data
            this.settings         = data.settings
            this.company_name     = data.company_name     // Company name for disclaimer
            this.serviceLocale    = data.serviceCurrency  // Country locale configuration

            this.prefillCustomer()

            this.$nextTick(() => this.$emit('ready'))

        }, () => {
            this.$notify.error({
                title: 'Error',
                message: 'There was an error saving the record',
                offset: 100
            })
        });

    },

    methods: {

        prefillCustomer(){

            if(this.customer){
                this.quoteForm = {...this.quoteForm, ...this.customer}
            }
        },

        // Return the placeholder for the specified input name, if not found return default
        _placeholder(name)
        {
            if(this.serviceLocale.bookForm !== undefined)
                return this.serviceLocale.bookForm[name] || false
        },

        searchZillow(search) {

            this.$http({
                url: `booking/search_data`,
                method: 'POST',
                data: {
                    search: search,
                }
            }).then((res) => {

                if (res.data != false) {
                    this.bookZillow.zillow_active = true
                    this.bookZillow.zillow_id = res.data.data.zillow_id
                    this.bookZillow.images = res.data.data.images
                    this.bookZillow.bedrooms = res.data.data.bedrooms
                    this.bookZillow.bathrooms = res.data.data.bathrooms
                    this.bookZillow.sqft = res.data.data.sqft
                }

            }, (err) => {
                console.log(err)
            })

        },

        setPlace(place) {

            if (!place?.geometry) {
                this.quoteForm.street_address = place.target.value
                return;
            }

            this.quoteForm.street_address = place.name;
            place.address_components.forEach((component) => {
                if (component.types.includes('locality')) {
                    this.quoteForm.city = component.long_name;
                }
                if (component.types.includes('administrative_area_level_1')) {
                    this.quoteForm.selected_state = component.short_name;
                }
                if (component.types.includes('postal_code')) {
                    this.quoteForm.zipcode = component.long_name;
                }
            });
            //update the coordinates
            this.coordinates.lat = place.geometry.location.lat();
            this.coordinates.lng = place.geometry.location.lng();

            let search = this.quoteForm.street_address + ' ' + this.quoteForm.city + ' ' + this.quoteForm.selected_state + ' ' + this.quoteForm.zipcode
            if (this.serviceLocale.short_name == 'CA' || this.serviceLocale.short_name == 'US') {
                this.searchZillow(search)
            }

        },

        // Load query string vars into the form inputs
        populateInputs(event)
        {
            var app = this

            // Scroll Price box Attempts
            if(event.data.type == 'scroll' ){

                if (Math.abs(event.data.top - this.priceBoxTop ) >= 2) {

                    if(app.clientId == 126)
                        this.priceBoxTop =  event.data.top - 550
                    else
                        this.priceBoxTop =  event.data.top
                }
            }

            if(event.data.type == 'setParams' ){

                var aux_selected = [];

                Object.keys(event.data.params).forEach(function(key){

                    var param = event.data.params[key];

                    this.$set(this.quoteForm, key, param)

                }.bind(this))

                this.$nextTick(tick =>{

                    Object.keys(event.data.params).forEach(function(key){

                        var param = event.data.params[key];
                        var [name, index] = key.split('=')[0].split(/[\[\]]+/)

                    }.bind(app))

                })
            }
        },

        quoteStore()
        {
            let phoneValidated = phoneValidator(this.quoteForm.phone,'',true);

            this.$http({
                url: `quote_store`,
                method: 'POST',
                data: {
                    city           : this.quoteForm.city,
                    hour           : this.quoteForm.selected_hour,
                    state          : this.quoteForm.selected_state,
                    email          : this.quoteForm.email,
                    phone          : phoneValidated[0],
                    zipcode        : this.quoteForm.zipcode,
                    client_id      : this.clientId,
                    last_name      : this.quoteForm.last_name,
                    first_name     : this.quoteForm.first_name,
                    apt_number     : this.quoteForm.apt_number,
                    selected_date  : this.quoteForm.selected_date,
                    street_address : this.quoteForm.street_address,
                    customer_notes : this.quoteForm.customerNotes,
                }
            }).then((res) => {
                this.error           = false;
                this.done            = true
                this.spinner_actived = false
            }, () => {
                this.spinner_actived = false
                this.$notify.error({
                    title: 'Error',
                    message: 'There was an error saving the record',
                    offset: 100
                })
            })

        },

        quote()
        {
            this.spinner_actived = true

            this.$refs['quoteForm'].validate((valid, errors) => {
                if (valid) {

                    this.error = false
                    this.quoteStore()

                } else {
                    this.error           = true;
                    this.spinner_actived = false

                    return false;
                }
            });

        }

    },

    watch: {

        'customizer.appearance': {
            deep: true,
            immediate: true,
            handler() {

                if (this.customizer.appearance?.accentColor) {
                    document.querySelector(":root").style.setProperty('--color-primary', this.customizer.appearance.accentColor);
                    document.querySelector(":root").style.setProperty('--input-border-radius', this.customizer.appearance.inputBorderRadius + 'px');
                    document.querySelector(":root").style.setProperty('--form-border-radius', this.customizer.appearance.formBorderRadius + 'px');
                }
            }
        },

    },

    computed: {

        phoneWithPrefix()
        {
            return this.serviceLocale.phone_prefix + this.quoteForm.phone;
        },

        currencySymbol()
        {
            return this.serviceLocale.currency[2]
        },

    }
}
</script>

<style>
    :root {
        --color-primary: rgb(74, 126, 243);
        --input-border-radius: 10px;
        --form-border-radius: 20px;
    }
</style>

<style lang="scss" scoped>

    @font-face {
        font-family: 'Inter';
        src: url('../bookingForm/assets/fonts/inter.woff2') format("woff2");
    }
    * {
        font-family: 'Inter', sans-serif;
    }
    h2 {
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        margin-top: 0;
        margin-bottom: 8px;
    }
    p {
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        margin: 0;
        color: #8492A6;
    }
    .quote-container {
        max-width: 760px !important;
        height: 100%;
        width: 100vw !important;
    }
    .form-wrapper {
        margin: 0 auto;
        display: flex;
        justify-content: center;
    }
    .card {
        background-color: white;
        padding: 40px;
        border-radius: var(--form-border-radius);
    }
    .section-header {
        margin-bottom: 16px;
    }
    // FORM ITEMS
    .el-form-item::v-deep {
        margin-bottom: 16px;

        .el-form-item__label {
            font-size: 13px;
            font-weight: 500;
            line-height: 20px;
            color: #8492A6;
            margin-bottom: 5px;
            display: flex;
            flex-direction: row-reverse;
            white-space: nowrap;

            &:before {
                margin-right: 0 !important;
                margin-left: 4px;
                color: #8492A6 !important;
            }
        }
        .el-form-item__content {
            line-height: unset;

            .el-form-item__error {
                font-size: 10px;
                padding-top: 3px;
            }
        }

        &:not(.is-error) {
            .el-input__inner {
                border-color: #E5E9EF;
            }
        }

        &.is-error {
            .el-input-group--prepend {
                .el-input-group__prepend {
                    border-color: #F56C6C;

                }
            }
            .el-form-item__content {
                .gmap-autocomplete {
                    .pac-target-input {
                        border-color: #F56C6C;
                    }
                }
            }
            .el-select {
                .el-input__inner {
                    border-color: #F56C6C;
                }
            }
        }
    }

    // INPUTS
    .el-input::v-deep {
        .el-input__inner {
            padding: 10px 16px;
            border-radius: var(--input-border-radius);
            height: 44px;
        }

        &.el-input-group--prepend {
            .el-input-group__prepend {
                border-radius: var(--input-border-radius) 0 0 var(--input-border-radius);
            }
            .el-input__inner {
                border-left: none;
                border-radius: 0 var(--input-border-radius) var(--input-border-radius) 0;
            }
        }
    }

    // TEXTAREAS
    .el-textarea::v-deep {
        .el-textarea__inner {
            font-family: 'Inter', sans-serif;
            border: 1px solid #E5E9EF;
            padding: 10px 16px;
            border-radius: var(--input-border-radius);
        }
    }

    // SELECTS
    .el-select::v-deep {
        width: 100%;
        margin-bottom: 0;

        .el-input__inner {
            border: 1px solid #E5E9EF;
            padding: 10px 16px;
            border-radius: var(--input-border-radius);
            height: 44px;
        }
    }

    // BUTTONS
    .el-button {
        border: none;
        border-radius: var(--input-border-radius);
        box-sizing: border-box;
        height: 44px;
        font-size: 16px;
        font-weight: 500;
        width: 100%;

        &.el-button--primary {
            background-color: var(--color-primary);

            &:hover {
                background-color: var(--color-primary);
            }
        }
        &.is-disabled {
            opacity: 0.4;
        }
    }

    // GOOGLE ADDRESS AUTOCOMPLETE
    .gmap-autocomplete::v-deep {
        .pac-target-input, input {
            border: 1px solid #E5E9EF;
            padding: 10px 16px;
            border-radius: var(--input-border-radius);
            box-sizing: border-box;
            font-size: 14px;
            -webkit-appearance: none;
            display: inline-block;
            height: 44px;
            outline: none;
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            width: 100%;

            &::placeholder {
                color: #606266;
                opacity: 0.5;
                font-weight: 500;
            }

        }
    }

    // RESPONSIVE DESIGN
    @media (max-width: 768px) {
        .card {
            padding: 30px 24px;
        }
    }


</style>
